/**
 * Created by jv on 16/05/2017.
 */
const utils = require("Sources/utils/utils");

module.exports = class DialogTemplate
{
  constructor(options)
  {
    if(utils.isNull(options))
    {
      throw "options must be defined";
    }

    this.dialogId = utils.isNotNull(options.dialogId) ? options.dialogId : utils.generateElementId("dialog-");

    this.title = options.title;
    this.dialogContent = options.dialogContent;
    this.disposable = utils.isBoolean(options.disposable) ? options.disposable : true;

    this.confirmText = options.confirmText;
    this.cancelText = options.cancelText;
    this.cancelTopRight = utils.isBoolean(options.cancelTopRight) ? options.cancelTopRight : false;

    this.onConfirm = options.onConfirm;
    this.onCancel = options.onCancel;

    this.create();
  }

  create()
  {
    if(this._initialized !== true)
    {
      this.renderDialog();

      this.dialogEl.appendTo("body");

      this.dialogEl.modal({
        backdrop: this.disposable ? true : "static",
        keyboard: this.disposable,
        show: false
      });

      this.setUpDialogEventListeners();

      this._initialized = true;
    }
  }

  renderDialog()
  {
    this.dialogEl = $("<div id='" + this.dialogId + "' class='modal fade'>" +
                        "<div class='modal-dialog'>" +
                          "<div class='modal-content clearfix'>" +
                          "</div>" +
                        "</div>" +
                      "</div>");

    this.renderDialogHeader();
    this.renderDialogContent();
    this.renderDialogFooter();

    this.setUpEventListeners();
  }

  renderDialogHeader()
  {
    var dialogContentEl = this.dialogEl.find(".modal-content");

    if(utils.isNotNull(dialogContentEl) && dialogContentEl.length && utils.isNotNull(this.title))
    {
      var dialogHeader = "<div class='modal-header'><h4 class='dialog-title'>" + this.title + "</h4></div>";
      dialogContentEl.append(dialogHeader);
    }
  }

  renderDialogContent()
  {
    var dialogContentEl = this.dialogEl.find(".modal-content");

    if(utils.isNotNull(dialogContentEl) && dialogContentEl.length)
    {
      var dialogBodyEl = $("<div class='modal-body'></div>");
      dialogBodyEl.append(this.dialogContent);

      dialogContentEl.append(dialogBodyEl);
    }
  }

  renderDialogFooter()
  {
    var that = this;
    var dialogContentEl = that.dialogEl.find(".modal-content");

    if(utils.isNotNull(dialogContentEl) && dialogContentEl.length)
    {
      var dialogFooterEl = $("<div class='modal-footer'></div>");

      if(utils.isNotNull(that.confirmText))
      {
        var confirmBtn = $("<button class='btn btn-primary dialog-confirm-btn' type='button'>" + that.confirmText + "</button>");

        confirmBtn.on("click", function(e)
        {
          if(utils.isFunction(that.onConfirm))
          {
            that.onConfirm();
          }
        });

        dialogFooterEl.append(confirmBtn)
      }

      if(utils.isNotNull(that.cancelText) || that.cancelTopRight === true)
      {
        var classNames = "btn btn-primary dialog-cancel-btn";
        var innerHTML = that.cancelText;

        if(that.cancelTopRight)
        {
          classNames = "btn btn-icon frameless cross-circle dark-grey pull-right";
          innerHTML = "";
        }

        var cancelBtn = $("<button class='" + classNames + "' type='button'>" + innerHTML +"</button>")

        cancelBtn.on("click", function()
        {
          that.cancel();
        });

        if(that.cancelTopRight)
        {
          that.dialogEl.find(".modal-content").prepend(cancelBtn);
        }
        else
        {
          dialogFooterEl.append(cancelBtn);
        }
      }

      dialogContentEl.append(dialogFooterEl);
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.dialogEl) && this.dialogEl.length && this._destroying !== true)
    {
      this._destroying = true;

      this.hide();
    }
  }

  show()
  {
    this.dialogEl.modal("show");
  }

  hide()
  {
    this.dialogEl.modal("hide");
  }

  cancel()
  {
    this.hide();

    if(utils.isFunction(this.onCancel))
    {
      this.onCancel();
    }
  }

  setUpDialogEventListeners()
  {
    var that = this;

    this.dialogEl.on("hide.bs.modal", function(e)
    {

    });

    this.dialogEl.on("hidden.bs.modal", function(e)
    {
      if(that._destroying)
      {
        that.dialogEl.remove();
        that._initialized = false;
        that._destroying = false;
      }
    });

    this.dialogEl.on("show.bs.modal", function(e)
    {

    });

    this.dialogEl.on("shown.bs.modal", function(e)
    {

    });
  }

  setUpEventListeners()
  {

  }
};



// WEBPACK FOOTER //
// ./app/js/templates/dialog.template.js